import { useEffect, useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { labApi } from '@/lib/api';

export function AssetTextReplacementModal({ productId, target, onClose, onSaved }: {
  productId: string; target: { id: string; kind: 'knowledge' | 'content' }; onClose: () => void; onSaved: () => void;
}) {
  const [find, setFind] = useState('');
  const [replacement, setReplacement] = useState('');
  const [preview, setPreview] = useState<{ count: number; fields: number; updatedAt: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let current = true;
    setPreview(null);
    setError('');
    if (!find) return;
    const timer = window.setTimeout(() => {
      labApi.replaceAssetText(productId, { targetId: target.id, kind: target.kind, find, replacement, apply: false })
        .then(res => { if (current) setPreview(res.data.data); })
        .catch(err => { if (current) setError(typeof err.response?.data?.error === 'string' && err.response.data.error !== 'Validation error' ? err.response.data.error : 'Nie udało się sprawdzić wystąpień.'); });
    }, 300);
    return () => { current = false; window.clearTimeout(timer); };
  }, [find, replacement, productId, target.id, target.kind]);
  const save = async () => {
    if (!preview) return;
    setBusy(true); setError('');
    try {
      await labApi.replaceAssetText(productId, { targetId: target.id, kind: target.kind, find, replacement, apply: true, expectedUpdatedAt: preview.updatedAt });
      onSaved(); onClose();
    } catch (err: any) {
      setError(typeof err.response?.data?.error === 'string' && err.response.data.error !== 'Validation error' ? err.response.data.error : 'Nie udało się zapisać zamiany. Odśwież podgląd.');
    } finally { setBusy(false); }
  };
  return <Modal isOpen onClose={onClose} title="Zamień tekst" description="Wpisz tekst do znalezienia i jego nową wersję. Wielkość liter ma znaczenie. Zamiana obejmuje tylko aktualnie otwarty materiał."
    footer={<div className="flex justify-between gap-3"><button className="btn-primary" disabled={busy || !preview?.count || !replacement || find === replacement} onClick={() => void save()}>{busy ? 'Zapisuję...' : 'Zamień wszystkie'}</button><button className="btn-secondary" onClick={onClose}>Zamknij</button></div>}>
    <div className="space-y-4">
      <label className="block text-sm">Znajdź<input autoFocus className="input mt-1 w-full" value={find} onChange={event => setFind(event.target.value)} disabled={busy} /></label>
      <label className="block text-sm">Zamień na<input className="input mt-1 w-full" value={replacement} onChange={event => setReplacement(event.target.value)} disabled={busy} /></label>
      <p aria-live="polite" className="text-sm text-text-muted">{preview ? `Znaleziono ${preview.count} wystąpień w ${preview.fields} polach.` : error ? 'Sprawdzenie nie powiodło się. Zmień frazę, aby spróbować ponownie.' : find ? 'Sprawdzam...' : 'Wpisz frazę do znalezienia.'}</p>
      {error && <p role="alert" className="text-sm text-danger">{error}</p>}
    </div>
  </Modal>;
}
